import React from "react";
import { Permission } from "types";
import { CustomMenuItems } from "./CustomMenuItems";
import { MenuItem } from "./MenuItem";
import { IsGranted } from "@/components/Common/IsGranted";
import { getPermissions } from "@/stores/globalStore";

export const ReportMenuItems = () => {
    const permissions = getPermissions();
    return (
        <>
            {permissions.canViewReportAnalytics && (
                <MenuItem isSubMenuItem route="reports/analytics" label="Analytics" />
            )}

            {permissions.canViewReportCustomers && (
                <MenuItem isSubMenuItem route="reports/customerAnalytics" label="Customer Analytics" />
            )}

            {permissions.canViewReportEarnings && (
                <MenuItem isSubMenuItem route="reports/earningsReport" label="Earnings Report" />
            )}

            <IsGranted permissions={[Permission.REPORTS_XOLABOT_VIEW]}>
                <MenuItem isSubMenuItem route="reports/xolabotEarningsReport" label="XolaBot Earnings Report" />
            </IsGranted>

            {permissions.canViewReportGiftOffers && (
                <MenuItem isSubMenuItem route="reports/gifts" label="Gifts / Store Credits" />
            )}

            {permissions.canViewCustomReports && (
                <MenuItem isSubMenuItem route="reports/customReports" label="Custom Reports" />
            )}

            {permissions.canViewReportPayouts && <MenuItem isSubMenuItem route="reports/payouts" label="Payouts" />}

            {permissions.canViewGratuity && <MenuItem isSubMenuItem route="reports/gratuities" label="Gratuities" />}

            {permissions.canViewMerchandise && (
                <MenuItem isSubMenuItem route="reports/merchandiseLedger" label="Merchandise Ledger" />
            )}

            {permissions.canViewReportAffiliateCommissions && (
                <MenuItem
                    isSubMenuItem
                    label="Distribution Partners"
                    route="reports/distributionPartnersReconciliation"
                />
            )}

            {permissions.canViewDisputeReport && <MenuItem isSubMenuItem route="reports/disputes" label="Disputes" />}

            <CustomMenuItems route="reports" />
        </>
    );
};
